export default __webpack_public_path__ + "44a8770726dfb21b700ba1592a313491.svg";